module.exports = __webpack_public_path__ + "img/检查2.b79b60bf.svg";